var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.decisionMade)?_c('span'):(_vm.showExperienceA || _vm.showExperienceB)?_c('TestA'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }